import { useLocation } from "react-router-dom";

const SummaryBulk = () => {
  const location = useLocation();

  const summaryCounts = location.state?.summaryCounts || {};

  const handleDownload = () => {
    console.log("Downloading report...");
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-green-900">Bulk Repayments</h1>
      <p className="font-bold mt-2">
        Repayments Successfully Uploaded And Updated.
      </p>
      <p className="text-gray-700">Here is a summary.</p>
      <div className="mt-4 bg-[#E6FAF8] p-4 rounded-r-lg border-l-[6px] border-green-900">
        <h2 className="font-semibold text-lg text-green-900">Summary Report</h2>
        <ul className="mt-4 list-disc list-inside">
          <li>Flash Loans Updated: {summaryCounts.flashLoan}</li>
          <li>Emergency Loans Updated: {summaryCounts.emergencyLoan}</li>
          <li>Savings Updated: {summaryCounts.savings}</li>
          <li>Shares Updated: {summaryCounts.shares}</li>
          <li>Normal Loans Updated: {summaryCounts.normalLoan}</li>
          <li>Jijenge Loans Updated: {summaryCounts.jijengeLoan}</li>
          <li>Development Loans Updated: {summaryCounts.developmentLoan}</li>
        </ul>

        <div className="mt-4 flex justify-end">
          <button
            onClick={handleDownload}
            className="text-green-700 underline hover:underline"
          >
            Download Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryBulk;
